"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.link");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RichText = _interopRequireDefault(require("../RichText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Let `alertBarType` be a list of available colours the hero banner may be painted.
Let `type` be a string mapping to a colour the alert bar must be painted.
Let `type` only contain uppercase characters.
If `type` is present in `alertBarType`.
	Paint hero alert bar using `type`.
Else apply default colour.
*/
var AlertBar = /*#__PURE__*/function (_React$Component) {
  _inherits(AlertBar, _React$Component);

  var _super = _createSuper(AlertBar);

  function AlertBar() {
    var _this;

    _classCallCheck(this, AlertBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_detectBrowser", function () {
      // Opera 8.0+
      var isOpera = // eslint-disable-next-line no-undef
      !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0; // Firefox 1.0+

      var isFirefox = typeof InstallTrigger !== 'undefined'; // Safari 3.0+ "[object HTMLElementConstructor]"

      var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
        return p.toString() === '[object SafariRemoteNotification]'; // eslint-disable-next-line no-undef
      }(!window.safari || typeof safari !== 'undefined' && safari.pushNotification); // Internet Explorer 6-11


      var isIE =
      /*@cc_on!@*/
      false || !!document.documentMode; // Edge 20+

      var isEdge = !isIE && !!window.StyleMedia; // Chrome 1 - 79

      var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
      return {
        isIE: isIE,
        isOpera: isOpera,
        isFirefox: isFirefox,
        isChrome: isChrome,
        isSafari: isSafari,
        isEdge: isEdge
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_checkBrowserEligibility", function (browsersObj, browserSpecification) {
      var showSiteAlert = true;

      for (var prop in browsersObj) {
        if (browsersObj.hasOwnProperty(prop)) {
          if (browsersObj[prop] === true) showSiteAlert = browserSpecification[prop];
        }
      }

      return showSiteAlert;
    });

    return _this;
  }

  _createClass(AlertBar, [{
    key: "_renderMessage",
    value: function _renderMessage(alert) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: 0,
        className: "l-padding global-alert-bar__content"
      }, alert.text && /*#__PURE__*/_react.default.createElement(_RichText.default, {
        content: alert.text
      }), alert.text && alert.link && /*#__PURE__*/_react.default.createElement("a", {
        className: "global-alert-bar__link",
        href: alert.link
      }, 'Read more', /*#__PURE__*/_react.default.createElement("span", {
        className: "vh"
      }, alert.altText)));
    }
    /*
    	Data passed can be list of array alert. However the first i.e the latest message will be rendered.
    */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showAlertMessage = _this$props.showAlertMessage,
          data = _this$props.data,
          browserSpecification = _this$props.browserSpecification;
      var alert = data && data.length >= 1 ? data[0] : null;

      var browsersObj = this._detectBrowser();

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showAlertMessage && alert && alert.text && this._checkBrowserEligibility(browsersObj, browserSpecification) && /*#__PURE__*/_react.default.createElement("section", {
        className: "global-alert-bar"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "global-alert-bar__overlay"
      }), this._renderMessage(alert)));
    }
  }]);

  return AlertBar;
}(_react.default.Component);

exports.default = AlertBar;

_defineProperty(AlertBar, "defaultProps", {
  data: [],
  showAlertMessage: false,
  browserSpecification: {
    isIE: true,
    isOpera: true,
    isFirefox: true,
    isChrome: true,
    isSafari: true,
    isEdge: true
  }
});

_defineProperty(AlertBar, "propTypes", {
  data: _propTypes.default.array,
  showAlertMessage: _propTypes.default.bool,
  browserSpecification: _propTypes.default.object
});
//# sourceMappingURL=AlertBar.js.map